var PageTransition = {

	init: function(){
		
		//console.log("PAGE TRANSITION INIT");

		$(window).bind('beforeunload', function(){
			//console.log('_debug_ : hide body');
			$(".page-transition").removeClass("animated").addClass("hidden").delay("40").removeClass("hidden").addClass("animated visible");
		});

		$(window).on('load', function(){
			Debug.log('_debug_ : hide body');
			$(".page-transition").addClass("animated hidden").removeClass("visible");
		});
		
		/* A AMELIORER, CAS DE FIREFOX QUI LANCE LE LOAD AVANT LE READY */
		
		setTimeout(function(){
			$(".page-transition").addClass("animated hidden").removeClass("visible");
		}, 1000);
	},
}

$(document).ready(function(){
	Debug.log("PAGE TRANSITION READY");
	PageTransition.init();
})
